import { z } from 'zod';

/////////////////////////////////////////
// APPLETS SCHEMA
/////////////////////////////////////////

export const AppletsSchema = z.object({
  appletId: z.number().int(),
  cityId: z.number().int(),
  appletName: z.string(),
  appletType: z.string(),
  templateName: z.string(),
  appletData: z.string(),
  deleted: z.number().int(),
})

export type Applets = z.infer<typeof AppletsSchema>

export default AppletsSchema;
